import React from 'react';
import {withStyles, Hidden, AppBar, FormControl, MenuItem, Select} from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import {FuseNavigation, FuseLayouts} from '@fuse';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from 'store/actions';
import axios from 'axios/index';

const styles = theme => ({
    root  : {
        '& .user': {
            '& .username, & .email': {
                transition: theme.transitions.create('opacity', {
                    duration: theme.transitions.duration.shortest,
                    easing  : theme.transitions.easing.easeInOut
                })
            }
        }
    },
    avatar: {
        width     : 72,
        height    : 72,
        position  : 'absolute',
        top       : 92,
        padding   : 8,
        background: theme.palette.background.default,
        boxSizing : 'content-box',
        left      : '50%',
        transform : 'translateX(-50%)',
        '& > img' : {
            borderRadius: '50%'
        }
    }
});


function MainNavbar({classes, navigation, layoutStyle, user})
{
    function onChangeTahun(event){
        // alert('tew');
        
        localStorage.setItem('tahun', event.target.value);

        const baseUrl = localStorage.getItem('api_domain');
        const request = axios.get(baseUrl + '/api/plainKuesioner', {
            params: {
                tahun: event.target.value,
                token: localStorage.getItem('jwt_token'),
                tingkat_instrumen_id: 1
            }
        });
        request.then((response) => {
            // alert('oke');
            // console.log(response.data[0].instrumen_id);
            localStorage.setItem('instrumen_id', response.data[0].instrumen_id);
            window.location.href=localStorage.getItem('root_base');
        });


    }

    function UserHeader()
    {
        // return (<div></div>)
        return (
            <AppBar
                position="static"
                color="primary"
                elevation={0}
                style={{height: '50px',padding:10,background:'#616161',marginBottom:'5px'}}
                className="user relative flex flex-col items-center justify-center pt-24 pb-64 mb-32 z-0"
            >
                <FormControl variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                    <Select
                        value={localStorage.getItem('tahun')}
                        onChange={onChangeTahun}
                        style={{color: 'white'}}
                        
                    >
                        <MenuItem style={{ color: 'gray' }} value="2020">Tahun Pendataan 2020</MenuItem>
                        {/* <MenuItem style={{ color: 'gray' }} value="2019">Tahun Pendataan 2019</MenuItem>
                        <MenuItem style={{ color: 'gray' }} value="2018">Tahun Pendataan 2018</MenuItem>
                        <MenuItem style={{ color: 'gray' }} value="2017">Tahun Pendataan 2017</MenuItem> */}
                    </Select>
                </FormControl>
                {/* <FormControl variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                    {localStorage.getItem('sekolah_id_pengawas')}
                </FormControl> */}
                {/* <Typography className="username text-16 whitespace-no-wrap" color="inherit">{user.data.displayName}</Typography>
                <Typography className="email text-13 mt-8 opacity-50 whitespace-no-wrap" color="inherit">{user.data.email}</Typography>
                <Avatar
                    className={classNames(classes.avatar, "avatar")}
                    alt="user photo"
                    src={user.data.photoURL && user.data.photoURL !== '' ? user.data.photoURL : "assets/images/avatars/profile.jpg"}
                /> */}
            </AppBar>
        );
    }

    let tmpNavi = [];

    if(localStorage.getItem('user') !== '' && localStorage.getItem('user') !== null){
        switch (Number(JSON.parse(localStorage.getItem('user')).peran_id)) {
            case 13: // pengawas
                if(localStorage.getItem('aslinya_ops') !== '1'){
                    navigation[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
                }
                for (let index = 0; index < navigation[0].children.length; index++) {
                    const element = navigation[0].children[index];
                    if(element.id !== 'unggah-hasil-supervisi' && element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component'){
                        // console.log(option.id);
                        tmpNavi.push(element);
                    }
                } // menghilangkan menu kirim data
                break;
            case 14: // komite
                if(localStorage.getItem('aslinya_ops') !== '1'){
                    navigation[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
                }
                for (let index = 0; index < navigation[0].children.length; index++) {
                    const element = navigation[0].children[index];
                    if(element.id !== 'unggah-hasil-supervisi' && element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component' && element.id !== 'rapor-mutu-component' && element.id !== 'verval-supervisi-component'){
                        // console.log(option.id);
                        tmpNavi.push(element);
                    }
                } // menghilangkan menu kirim data
                break;
            case 53: // ptk
                // console.log(localStorage.getItem('pengguna_id_ops'));
                // if(localStorage.getItem('pengguna_id_ops') === ''){
                    if(localStorage.getItem('aslinya_ops') !== '1'){
                        navigation[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
                    }
                    for (let index = 0; index < navigation[0].children.length; index++) {
                        const element = navigation[0].children[index];
                        if(element.id !== 'unggah-hasil-supervisi' && element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component' && element.id !== 'rapor-mutu-component'  && element.id !== 'verval-supervisi-component'){
                            // console.log(option.id);
                            tmpNavi.push(element);
                        }
                    } // menghilangkan menu kirim data
                // }else{
                //     // for (let index = 0; index < navigation[0].children.length; index++) {
                //     //     const element = navigation[0].children[index];
                //     //     tmpNavi.push(element);
                //     // }
                //     if(localStorage.getItem('tipe_app') !== '2'){
                //         for (let index = 0; index < navigation[0].children.length; index++) {
                //             const element = navigation[0].children[index];
                //             if(element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component'){
                //                 // console.log(option.id);
                //                 tmpNavi.push(element);
                //             }
                //         }
                //     }
                // }
                break;
            case 90: // Peserta Didik
                // if(localStorage.getItem('pengguna_id_ops') === ''){
                    if(localStorage.getItem('aslinya_ops') !== '1'){
                        navigation[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
                    }
                    for (let index = 0; index < navigation[0].children.length; index++) {
                        const element = navigation[0].children[index];
                        if(element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component' && element.id !== 'rapor-mutu-component' && element.id !== 'verval-supervisi-component'){
                            // console.log(option.id);
                            tmpNavi.push(element);
                        }
                    } // menghilangkan menu kirim data
                // }else{
                //     // for (let index = 0; index < navigation[0].children.length; index++) {
                //     //     const element = navigation[0].children[index];
                //     //     tmpNavi.push(element);
                //     // }
                //     if(localStorage.getItem('tipe_app') !== '2'){
                //         for (let index = 0; index < navigation[0].children.length; index++) {
                //             const element = navigation[0].children[index];
                //             if(element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component'){
                //                 // console.log(option.id);
                //                 tmpNavi.push(element);
                //             }
                //         }
                //     }
                // }
                // navigation[0].children = tmpNavi;
                // console.log(navigation[0].children);
                // navigation[0].children.map((option)=>{
                //     if(option.id !== 'kirim_data-component' && option.id !== 'konfirmasi-selesai-component'){
                //         // console.log(option.id);
                //         return option;
                //     }
                // });
                // console.log(navigation[0].children);
                // navigation[0].children.splice(4,1); // menghilangkan menu kirim data
                break;
            case 12: // Peserta Didik
                if(localStorage.getItem('aslinya_ops') !== '1'){
                    navigation[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
                }
                for (let index = 0; index < navigation[0].children.length; index++) {
                    const element = navigation[0].children[index];
                    if(element.id !== 'kirim_data-component' && element.id !== 'konfirmasi-selesai-component'){
                        // console.log(option.id);
                        tmpNavi.push(element);
                    }
                } // menghilangkan menu kirim data
                break;
            default:
                if(localStorage.getItem('tipe_app') !== '2'){
                    for (let index = 0; index < navigation[0].children.length; index++) {
                        const element = navigation[0].children[index];
                        if(element.id !== 'kirim_data-component'){
                            // console.log(option.id);
                            tmpNavi.push(element);
                        }
                    }
                }
                break;
        }
    }

    switch (JSON.parse(localStorage.getItem('user')).peran_id) {
        case 53:
            // delete tmpNavi[4];
            tmpNavi.splice(4,2);
            break;
        
        default:
            break;
        }
    // console.log(tmpNavi);

    navigation[0].children = tmpNavi;

    // console.log(navigation);

    const navigationLayout = FuseLayouts[layoutStyle].type;

    return (
        <div className={classes.root}>
            {navigationLayout === 'vertical' ? (
                <React.Fragment>
                    <UserHeader/>
                    <FuseNavigation navigation={navigation} layout={navigationLayout}/>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Hidden lgUp>
                        <UserHeader/>
                    </Hidden>
                    <FuseNavigation navigation={navigation} layout={navigationLayout}/>
                </React.Fragment>
            )}

        </div>
    );
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        // setNavigation: FuseActions.setNavigation,
        getPlainKuesioner: Actions.getPlainKuesioner
    }, dispatch);
}

function mapStateToProps({fuse, auth, Instrumen})
{
    return {
        navigation : fuse.navigation,
        layoutStyle: fuse.settings.current.layout.style,
        user       : auth.user,
        plain_kuesioner: Instrumen.plain_kuesioner
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(MainNavbar)));



// WEBPACK FOOTER //
// ./src/main/MainNavbarContent.js